import { getHostname } from "./location-utils";

export const isLocalEnv = () => getHostname() === "localhost";
